import React from 'react';
import './LinkPreview.css';

const LinkPreview = ({ preview }) => {
  if (!preview) return null;

  const renderYouTubeEmbed = () => (
    <div className="link-preview youtube-preview">
      <div className="preview-embed">
        <iframe
          src={`https://www.youtube.com/embed/${preview.embedData.videoId}`}
          title={preview.title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="preview-info">
        <div className="preview-title">{preview.title}</div>
        {preview.description && (
          <div className="preview-description">{preview.description}</div>
        )}
        <div className="preview-source">🎥 YouTube</div>
      </div>
    </div>
  );

  const renderTwitterEmbed = () => (
    <div className="link-preview twitter-preview">
      <div className="preview-header">
        <span className="twitter-icon">🐦</span>
        <span className="preview-author">@{preview.embedData.author}</span>
      </div>
      <div className="preview-content">
        <div className="preview-title">{preview.title}</div>
        {preview.description && (
          <div className="preview-description">{preview.description}</div>
        )}
      </div>
      {preview.image && (
        <div className="preview-image">
          <img src={preview.image} alt="Tweet media" />
        </div>
      )}
      <div className="preview-source">Twitter</div>
    </div>
  );

  const renderSteamEmbed = () => (
    <div className="link-preview steam-preview">
      {preview.image && (
        <div className="preview-image">
          <img src={preview.image} alt={preview.title} />
        </div>
      )}
      <div className="preview-info">
        <div className="preview-title">{preview.title}</div>
        {preview.description && (
          <div className="preview-description">{preview.description}</div>
        )}
        <div className="preview-meta">
          {preview.embedData.price && (
            <span className="game-price">{preview.embedData.price}</span>
          )}
          {preview.embedData.rating && (
            <span className="game-rating">⭐ {preview.embedData.rating}</span>
          )}
        </div>
        <div className="preview-source">🎮 Steam Store</div>
      </div>
    </div>
  );

  const renderWebsiteEmbed = () => (
    <a
      href={preview.url}
      target="_blank"
      rel="noopener noreferrer"
      className="link-preview website-preview"
    >
      {preview.image && (
        <div className="preview-image">
          <img src={preview.image} alt={preview.title} />
        </div>
      )}
      <div className="preview-info">
        <div className="preview-title">{preview.title}</div>
        {preview.description && (
          <div className="preview-description">{preview.description}</div>
        )}
        <div className="preview-source">
          🔗 {new URL(preview.url).hostname}
        </div>
      </div>
    </a>
  );

  switch (preview.embedType) {
    case 'youtube':
      return renderYouTubeEmbed();
    case 'twitter':
      return renderTwitterEmbed();
    case 'steam':
      return renderSteamEmbed();
    case 'website':
    default:
      return renderWebsiteEmbed();
  }
};

export default LinkPreview;
